<app-navigation-panel></app-navigation-panel>

<app-toast></app-toast>

<router-outlet></router-outlet>
